"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var BadgeDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\twidth: 25%;\n\theight: 25%;\n\tright: 10%;\n\ttop: 10%;\n\tuser-select: none;\n\tpointer-events: none;\n\topacity: ", ";\n\t", "\n"], ["\n\tposition: absolute;\n\twidth: 25%;\n\theight: 25%;\n\tright: 10%;\n\ttop: 10%;\n\tuser-select: none;\n\tpointer-events: none;\n\topacity: ", ";\n\t", "\n"])), function (props) { return props.disabled ? "0.5" : "1"; }, function (props) { return props.theme.badge; });
var Counter = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tline-height: 1px;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\t", "\n"], ["\n\tline-height: 1px;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\t", "\n"])), function (props) { return props.theme.counter; });
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        return (react_1.default.createElement("div", { style: { display: 'inline-block', position: 'relative' }, className: this.props.className },
            this.props.children,
            this.props.count !== 0 &&
                react_1.default.createElement(BadgeDiv, { disabled: this.props.disabled === true, small: this.props.small === true },
                    react_1.default.createElement(Counter, { "data-automationid": "badge" }, this.props.count))));
    };
    Badge.propTypes = {
        /** Value to display on the badge */
        count: prop_types_1.default.oneOfType([prop_types_1.default.number.isRequired, prop_types_1.default.string.isRequired]),
        children: prop_types_1.default.node.isRequired,
        /* Shrink the badge */
        small: prop_types_1.default.bool,
        /* when this is true the badge will be faded */
        disabled: prop_types_1.default.bool
    };
    Badge.defaultProps = {
        count: 1,
        children: '',
    };
    return Badge;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Badge);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Badge.js.map